module.exports = __webpack_public_path__ + "static/media/V-ID-5.1f41f5b5.mp4";